import React from 'react';
import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';

import {
  isWeb,
  hasPhotoLikeComponent,
  checkCurrentGalleryNeedPay,
} from '../../utils/util';
import NormalButton from './NormalButton';
import RootStore from '../../store/RootStore';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

interface IDownloadButton {
  rootStore?: RootStore;
}
function DownloadButton(props: IDownloadButton) {
  const name = intl.get('Download-Pendent');
  const { wxuserStore } = props.rootStore!;
  const activeGallery = activeGalleryInstance.get();

  const canShowGalleryButtons = () => {
    return hasPhotoLikeComponent(window.pageDetail.template || []);
  };

  const isExhibitorPage = Number(window.pageDetail?.is_exhibitor) === 1;
  const hasPhotoData = activeGallery
    ? activeGallery.total !== 0 ||
      activeGallery.list.length > 0 ||
      activeGallery.hotList.length > 0 ||
      activeGallery.personList.length > 0
    : false;

  const showBottom = function () {
    //  如果是模拟用户, 那么就需要先授权
    if (
      wxuserStore.user.is_mock &&
      Number(window.configDetail.active_on) == 1
    ) {
      wxuserStore.auth();
      return false;
    }

    const visibleEvent = new Event('PENDENT_FOLD');
    visibleEvent.data = 1;
    window.dispatchEvent(visibleEvent);
    activeGallery?.setJigsaw({
      type: 'download',
      bottomShow: true,
    });
  };

  if (!canShowGalleryButtons()) {
    return null;
  }

  if (checkCurrentGalleryNeedPay()) {
    return null;
  }

  if (isExhibitorPage) {
    if (activeGallery && activeGallery.total === 0 && !hasPhotoData) {
      return null;
    }
    return <NormalButton onClick={showBottom}>{name}</NormalButton>;
  }

  if (
    (window.isweixin && !window.isweixinweb) ||
    isWeb()
  ) {
    if (!activeGallery || (activeGallery.total === 0 && !hasPhotoData)) {
      return null;
    }
    return <NormalButton onClick={showBottom}>{name}</NormalButton>;
  }

  return null;
}
export default inject('rootStore')(observer(DownloadButton));